import React from 'react';
import colors from '../../theme/colors';

const overlay = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const dialog = {
  background: colors.card,
  border: `1px solid ${colors.cardBorder}`,
  borderRadius: 12,
  padding: 24,
  minWidth: 360,
  maxWidth: '90vw',
  maxHeight: '80vh',
  overflow: 'auto',
};

export default function ConfirmDialog({ title, children, onConfirm, onCancel, confirmLabel = 'Confirm', danger = false }) {
  return (
    <div style={overlay} onClick={onCancel}>
      <div style={dialog} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 15, fontWeight: 700, color: colors.text, marginBottom: 16 }}>{title}</div>
        <div style={{ marginBottom: 20 }}>{children}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={onCancel} style={{
            padding: '8px 18px', borderRadius: 6, border: `1px solid ${colors.cardBorder}`,
            background: 'transparent', color: colors.textMuted, fontSize: 13, cursor: 'pointer',
          }}>
            Cancel
          </button>
          <button onClick={onConfirm} style={{
            padding: '8px 18px', borderRadius: 6, border: 'none',
            background: danger ? colors.danger : colors.accent,
            color: danger ? '#fff' : colors.bg,
            fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
